import DebounceSelect from 'components/debounce-select/select';
import AxiosUtils from 'utils/axios-utils';
import { API } from 'service/api-route';

// Giá trị của ô chọn người (labelInValue của antd Select).
export type UserPickerValue = { value: number; label: string } | undefined;

export function buildUserLabel(user: any): string {
  const full = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
  const head = user?.nickName || full || user?.username || user?.email || `User #${user?.id}`;
  const username = user?.username && user.username !== head ? ` (${user.username})` : '';
  return user?.email ? `${head}${username} — ${user.email}` : `${head}${username}`;
}

export const fetchUserOptions = async (search: string) => {
  const query = search.trim();
  if (query.length < 2) return [];
  const res: any = await AxiosUtils.get(API.searchUserAdmin, { query, limit: 20 });
  const list: any[] = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
  return list.map((user) => ({ value: user.id, label: buildUserLabel(user) }));
};

interface Props {
  value?: UserPickerValue;
  onChange?: (value: UserPickerValue) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large';
}

// Ô tìm người dùng (GET /users/search/admin?query=), dùng trong bộ lọc và modal.
const UserPicker = ({
  value,
  onChange,
  placeholder = 'Nhập tên/username/email',
  allowClear = true,
  disabled,
  style,
  size = 'middle',
}: Props) => (
  <DebounceSelect
    value={value}
    onChange={(next: any) => onChange?.(next || undefined)}
    placeholder={placeholder}
    fetchOptions={fetchUserOptions}
    allowClear={allowClear}
    disabled={disabled}
    size={size}
    style={{ width: '100%', ...style }}
  />
);

export default UserPicker;
